import React from "react";
import "./Preview.css";

const Preview = (props) => {
    return (
        <div className="Preview-container" onClick={props.action}>
            <img src={props.img} className="Preview-img" alt={props.caption} />
            <div className="Preview-caption">{props.caption}</div>
        </div>
    )
}

export default Preview;